const module = { name: 'video/jwplayer/freewheel', exports: {} }; const exports = module.exports;



import { Fandango_debugLog as debugLog } from 'require-core';



import { Fandango_cookie as Fandango_cookie_get_getCookie } from 'require-core';

const { get: getCookie } = Fandango_cookie_get_getCookie;


import { Fandango as Fandango_fwPlayer } from 'require-core';

const { fwPlayer } = Fandango_fwPlayer;


import { global_consts as global_consts_CookieNames } from 'require-core';

const { CookieNames } = global_consts_CookieNames;


const RegExes = {
    ID_CHARS: /[xy]/g,
}
function newClientToken() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(RegExes.ID_CHARS, (char) => {
        const rnd = Math.random() * 16 | 0;
        char = char === 'x' ? rnd : (rnd & 0x3 | 0x8);
        return char.toString(16);
    });
}
function loadPixel(fwUserID, fwSyncPixelURL, napiSyncPixelURL) {
    if (!fwUserID || !fwSyncPixelURL || !napiSyncPixelURL) {
        return;
    }
    const redirectURL = encodeURIComponent(napiSyncPixelURL + fwUserID);
    const pixel = document.createElement('img');
    pixel.id = 'fw_' + fwUserID;
    pixel.src = fwSyncPixelURL + redirectURL;
    pixel.style.width = '1px';
    pixel.style.height = '1px';
    pixel.style.display = 'none';
    document.getElementsByTagName('body')[0].appendChild(pixel);
}
function init(cb) {
    const { enabled, fwSyncPixelURL, napiSyncPixelURL } = fwPlayer || {};
    if (!enabled) {
        return debugLog.info(module.name, 'not enabled');
    }
    let fwUserID = getCookie(CookieNames.FREEWHEEL_USER_ID);
    if (!fwUserID) {
        fwUserID = newClientToken();
        loadPixel(fwUserID, fwSyncPixelURL, napiSyncPixelURL);
    }
    typeof cb === 'function' && cb(fwUserID);
}
module.exports = {
    init
};
export default module.exports;